module.exports = __webpack_public_path__ + "static/img/fefco427_2.4a8f12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco427_2.png
// module id = GPnT
// module chunks = 0